export default {
	sec_01: {
		title: {
			one: '비즈니스 결제 및',
			two: '자금 액세스',
		},
		desc: {
			one: '저희와 함께 송금, 지출 및 이동 시',
			two: '비즈니스 거래를 간소화 하십시오.',
		},
		btn: {
			one: '회원가입하기',
			two: '영업팀에 문의',
		},
	},
	sec_14: {
		desc: {
			one: '귀하의 비즈니스에 고도로 맞춤화 가능한 상거래 솔루션이 필요하십니까?',
		},
		btn: ' 기업용 JP WORLD PAY에 대해 알아보기.',
	},
	sec_03: {
		title: {
			one: '편리하게 구매하세요.',
		},
		desc: {
			one: 'JP WORLD PAY 잔액을 사용하여 온라인 및 직접 비즈니스 비용을 지불하십시오.',
		},
		one: {
			title: {
				one: '결제만 하면',
			},
			desc: {
				one: '자금을 전자적으로 보내 시간과 수고를 절약하십시오.',
			},
			btn: {
				one: '송금 방법 알아보기',
			},
		},
		two: {
			title: {
				one: '지불금',
			},
			desc: {
				one: '동시에 여러 사람과 장소에 ',
				two: '편하게 보낼 수 있습니다.',
			},
			btn: {
				one: '판매 대금에 대해 자세히 알아보기',
			},
		},
		three: {
			title: {
				one: '오늘',
				two: '시작하기',
			},
			desc: {
				one: 'JP WORLD PAY에 의존하는 판매자와 함께 하십시오.',
			},
			btn: {
				one: '비즈니스 계정에 가입',
			},
		},
	},
	sec_07: {
		title: {
			one: 'Please check',
			two: 'the notes',
		},
		list: {
			one: '1. JP WORLD PAY로 돈을 유지하고 사용하려면 JP WORLD PAY 비즈니스 계정 또는 JP WORLD PAY 잔액 계정이 있어야 합니다.',
			two: {
				one: '2. JP WORLD PAY Business Debit BlockChain 구입시 보너스 캐쉬백을 받을 수 있는 거래는 다음과 같습니다. 귀하가 서명하고 블록체인카드가 처리하는 신용 ​​거래. ',
				two: '캐쉬백 제안을 받을 수 없는 거래에는 현금 인출,',
				three: '현금 서비스로 처리되는 거래 또는 PIN을 사용하는 거래',
				four: 'JP WORLD PAY Business Debit BlockChain는 JP WORLD PAY에서 발급합니다. 카드는 BlockChain이 JP WORLD PAY가 허용되는 모든 곳에서 사용할 수 있습니다. 이는 카드 발급자일 뿐이며 JP WORLD PAY의 관련 계',
				five: '정이나 기타 제품, 서비스 또는 제안에 대해 책임을 지지 않습니다.',
			},
		},
	},
	common: {
		coming_soon: '준비 중입니다.',
	},
};
